import { render } from "./complianceFindings.vue?vue&type=template&id=3399db7c&scoped=true&ts=true"
import script from "./complianceFindings.vue?vue&type=script&lang=ts"
export * from "./complianceFindings.vue?vue&type=script&lang=ts"

import "./complianceFindings.vue?vue&type=style&index=0&id=3399db7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3399db7c"]])

export default __exports__